import React, { useContext, useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Rootstate } from '../../store';
import { useDispatch } from 'react-redux';
import { setMode } from '../../reducers/map/mapReducerActions';
import MeasureIcon from '../Icons/MeasureIcon';
import { EditorHotbarContext } from './EditorHotbar';

const MeasureEditor = () => {
    const { setActiveElement, id } = useContext(EditorHotbarContext);
    const { mode } = useSelector((state: Rootstate) => ({
        mode: state.map.mode,
    }), shallowEqual);

    const dispatch = useDispatch();

    useEffect(() => {
        if(id !== 'measure-editor' && mode === 'measure') {
            dispatch(setMode('default'));
        }
    }, [id]);

    const handleClick = () => {
        dispatch(setMode(mode === 'measure' ? 'default' : 'measure'));
        setActiveElement('measure-editor', <></>);
    };
    return (
        <div
            className={
                'flex items-center cursor-pointer justify-center h-16 min-w-18 rounded-bl-xl rounded-tl-xl'
                + ` ${mode  === 'measure' ? 'bg-mid-blue' : ''}`}
            onClick={handleClick}
        >
            <div className="pl-2 pr-2 ">
                <MeasureIcon className="h-10" />
            </div>
        </div>
    );
};

export default MeasureEditor;
